module.exports = __webpack_public_path__ + "static/kiwokbanner2024-e1896a45a894c5730a762b2e13aa0a37.png";